import axios, { AxiosResponse } from 'axios';
import { AppConfig } from '@/app.config';
import { IResponseData } from '@/interfaces/response.interface';
import { IAuth } from '@/modules/Auth/interfaces/auth.interface';
import { IRequestAuthRegistration } from '@/modules/Auth/interfaces/request-auth-registration.interface';
import {httpResource} from "@/resources/http.resource";
import {AuthStore} from "@/modules/Auth/stores/auth.store";
import {IRequestAuth} from "@/modules/Auth/interfaces/request-auth.interface";
import store from "@/store/store";

class AuthResource {
  registrationConfirm (token: string, registrationConfirm: string): Promise<AxiosResponse<IResponseData<IAuth.ResourceAuthRegistrationConfirmResponseDataResult>>> {
    return (axios.post(AppConfig.apiUrl, {
      action: IRequestAuthRegistration.ACTION_CONFIRM,
      params: IRequestAuthRegistration.convertToInputParamsToConfirmRegistration(registrationConfirm),
      token,
      version: 1.0
    }) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      response.data['result'] = IRequestAuthRegistration.convertToOutputResultToConfirmRegistration(response.data.result);
      return response;
    });
  }

  async removeCorp(payload: { corp: IRequestAuth.ILoginUserCorpsData }) {
    let asyncAction = async () => {
      const action = IRequestAuth.Action.Auth;
      const params: any = {
        command: IRequestAuth.Command.RemoveCorp,
        loginName: AuthStore.state.login,
        password: AuthStore.state.password,
        loginId: payload.corp.loginId,
        corpId: payload.corp.corpId,
      };
      const response = await httpResource.httpAction({ action, params });
      return response.data.result.userCorps;
    };
    return await store.dispatch('defaultResourceAction', { asyncAction });
  }
}

export const authResource = new AuthResource();
